import React, { Suspense } from 'react'

import { smartRound } from '@/shared/lib/math'
import { type DualAxesConfig } from '@ant-design/plots'
import { Spin } from 'antd'
import { useUnit } from 'effector-react'

import { COMMON_CHARTS_CONFIG } from '../../lib/constants'
import { $listensDuration } from '../../model/statistics-app-data.model'
import { StatisticsSectionWrapper } from '../StatisticsSectionWrapper'

const DualAxes = React.lazy(
  () => import('@ant-design/plots/es/components/dual-axes'),
)
export const ListensDurationChart = () => {
  const data = useUnit($listensDuration)
  const total = smartRound(data.reduce((acc, item) => acc + item.data, 0))
  const config: DualAxesConfig = {
    data,
    autoFit: true,
    padding: -15,
    xField: 'date',
    ...COMMON_CHARTS_CONFIG,
    children: [
      {
        type: 'line',
        yField: 'data',
        legend: false,
        axis: false,
        style: { lineWidth: 2, stroke: '#7F45E5' },
      },
      {
        type: 'area',
        yField: 'data',
        axis: false,
        style: {
          fill: 'linear-gradient(-90deg,rgba(255, 255, 255, 0) 0%, #7F45E5 100%)',
          fillOpacity: 0.6,
        },
      },
    ],
  }
  const middle = <span>{total}</span>
  const bottom = (
    <Suspense fallback={<Spin spinning />}>
      <DualAxes {...config} />
    </Suspense>
  )
  return (
    <StatisticsSectionWrapper
      title="Часов прослушивания"
      middle={middle}
      bottom={bottom}
    />
  )
}
